import { useAppDispatch } from './useRedux';

import {
  modalToggled,
  modalDataUpdated,
  modalRemoveAll,
} from '../features/modalSlice';
import { IModal } from '../types/modal';

function useModal() {
  const dispatch = useAppDispatch();

  const toggleModal = (props: IModal) => {
    dispatch(modalToggled(props));
  };

  const updateModalData = (data: any) => {
    dispatch(modalDataUpdated(data));
  };

  const closeAllModals = () => {
    dispatch(modalRemoveAll());
  };

  return {
    toggleModal,
    updateModalData,
    closeAllModals,
  };
}

export default useModal;
